import React, { useEffect, useState } from "react"

import withSettings from "./../hoc/withSettings"
import withOccupancyData from "./../hoc/withOccupancyData"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Occupancy from "../components/occupancy"

import ReactGA from 'react-ga';
ReactGA.initialize('UA-21938253-22');
ReactGA.pageview('/');


const IndexPage = (props) => {

  const [occupancyRows, setOccupancyRows] = useState('')

  /**
  * Create occupancy columns from fetched numbers
  */
  useEffect(() => {

    if (props.OCCUPANCY_DATA) {

      const occupancyRows = props.OCCUPANCY_DATA.map(data => {
        return <Occupancy
          key={data.key}
          title={data.title}
          showArrow={data.showArrow}
          occupancy={data.occupancy}
          realNumber={data.realNumber}
          correctionNumber={data.correctionNumber}
          correctionFactor={data.correctionFactor}
          buildingNumbers={data.buildingNumbers}
          debug={data.debug}

          COLOR_QUITE={props.COLOR_QUITE}
          COLOR_MODERATE={props.COLOR_MODERATE}
          COLOR_BUSY={props.COLOR_BUSY}
          LEVEL_QUITE={props.LEVEL_QUITE}
          LEVEL_BUSY={props.LEVEL_BUSY}

        />
      });

      setOccupancyRows(occupancyRows)

    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.OCCUPANCY_DATA])

  return (
    <Layout title={props.TITLE}>

      <SEO title={props.TITLE} lobbyscreen={props.lobbyscreen} />

      <div className="mainContainer" role="main">

        {occupancyRows}

      </div>

    </Layout>
  )
}

export default withSettings(withOccupancyData(IndexPage))
